// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VolumeStatus_wrapper__GynTV","volumeProgress":"VolumeStatus_volumeProgress__3f0-H","proportions":"VolumeStatus_proportions__zCl2R"};